import React from "react";

export default function TitleBar({ value, lastSavedAt, onChange, chapterNumber }) {
  return (
    <div className="chapter-meta-row" style={{ gap: 8 }}>
      {chapterNumber ? <span className="chapter-number-chip">Ch {chapterNumber}</span> : null}
      <input
        type="text"
        className="project-title"
        placeholder="Chapter title"
        value={value || ""}
        onChange={(e) => onChange?.(e.target.value)}
      />
    </div>
  );
}
